import { h } from "preact";
import { Link } from "react-router-dom";

import { classNames } from "../helpers";

export default function SegmentedControlItem({
  active,
  children,
  to,
  ...props
}) {
  let Tag = "span";
  if (to) {
    Tag = Link;
    props = { ...props, href: to };
  }
  return (
    <Tag
      class={classNames(
        "segmented-control__item",
        "waves-effect",
        "waves-light",
        active && "segmented-control__item--active",
        props.class
      )}
      role="menuitem"
      {...props}
    >
      <span>{children}</span>
    </Tag>
  );
}
